"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactTruncateMarkup = _interopRequireDefault(require("react-truncate-markup"));
var _angieslistReactComponents = require("angieslist-react-components");
var _stylesColors = require("angieslist-styles/js/stylesColors");
var _featuredSPInfoHover = _interopRequireDefault(require("./featuredSPInfoHover"));
var _certifiedPopOver = _interopRequireDefault(require("./certifiedPopOver"));
var _wrapperUtils = require("./utils/wrapperUtils");
require("./featuredSPCard.scss");
var FeaturedCardHeader = function FeaturedCardHeader(_ref) {
  var singleFeaturedPro = _ref.singleFeaturedPro,
    serviceProviderId = _ref.serviceProviderId,
    serviceProviderName = _ref.serviceProviderName,
    profileUrl = _ref.profileUrl,
    LinkWrapperComponent = _ref.LinkWrapperComponent,
    dataTrackingPropsForProfileViews = _ref.dataTrackingPropsForProfileViews;
  var truncatedSpName = function truncatedSpName() {
    return /*#__PURE__*/_react["default"].createElement(_reactTruncateMarkup["default"], {
      lines: 2
    }, /*#__PURE__*/_react["default"].createElement("h4", {
      className: "featured-sp-title"
    }, /*#__PURE__*/_react["default"].createElement("strong", null, serviceProviderName)));
  };
  var WrappedLink = (0, _wrapperUtils.createWrappedComponent)('a', LinkWrapperComponent);
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "featured-sp-card-header"
  }, !singleFeaturedPro ? /*#__PURE__*/_react["default"].createElement("div", {
    className: "featured-sp-info-hover hidden-xs hidden-sm"
  }, /*#__PURE__*/_react["default"].createElement(_featuredSPInfoHover["default"], {
    singleFeaturedPro: false
  })) : /*#__PURE__*/_react["default"].createElement(_angieslistReactComponents.Row, {
    className: "featured-title-row featured-title-row-single hidden-xs hidden-sm"
  }, /*#__PURE__*/_react["default"].createElement(_angieslistReactComponents.Col, {
    md: 8
  }, !!profileUrl ? /*#__PURE__*/_react["default"].createElement(WrappedLink, (0, _extends2["default"])({
    id: "featured-sp-card-sp-link-single-".concat(serviceProviderId),
    href: profileUrl,
    className: "featured-sp-title-link",
    style: {
      color: _stylesColors.white
    }
  }, dataTrackingPropsForProfileViews), truncatedSpName()) : truncatedSpName()), /*#__PURE__*/_react["default"].createElement(_angieslistReactComponents.Col, {
    md: 4,
    style: {
      textAlign: 'right',
      paddingRight: '24px',
      paddingTop: '8px',
      color: _stylesColors.white
    }
  }, /*#__PURE__*/_react["default"].createElement(_featuredSPInfoHover["default"], {
    singleFeaturedPro: singleFeaturedPro
  }))), /*#__PURE__*/_react["default"].createElement("div", {
    className: "hidden-lg hidden-md"
  }, /*#__PURE__*/_react["default"].createElement(_angieslistReactComponents.OverlayTrigger, {
    placement: "bottom",
    overlay: /*#__PURE__*/_react["default"].createElement(_certifiedPopOver["default"], null)
  }, /*#__PURE__*/_react["default"].createElement(_angieslistReactComponents.Row, {
    className: "featured-certified-row"
  }, /*#__PURE__*/_react["default"].createElement("i", {
    className: "icon icon-check-bullet",
    style: {
      marginRight: '6px'
    }
  }), "Angi Certified"))));
};
FeaturedCardHeader.propTypes = {
  serviceProviderId: _propTypes["default"].number.isRequired,
  singleFeaturedPro: _propTypes["default"].bool.isRequired,
  serviceProviderName: _propTypes["default"].string.isRequired,
  profileUrl: _propTypes["default"].string.isRequired,
  LinkWrapperComponent: _propTypes["default"].element,
  // eslint-disable-next-line react/forbid-prop-types
  dataTrackingPropsForProfileViews: _propTypes["default"].object
};
FeaturedCardHeader.defaultProps = {
  LinkWrapperComponent: null,
  dataTrackingPropsForProfileViews: {}
};
var _default = exports["default"] = FeaturedCardHeader;


//////////////////
// WEBPACK FOOTER
// ./node_modules/angieslist-composed-components/lib/featured/featuredCardHeader.js
// module id = 6469
// module chunks = 25